import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import classnames from 'classnames';
import { Body } from '../Body/Body.js';
import { Subhead } from '../Subhead/Subhead.js';
import { Heading } from '../Heading/Heading.js';

const Card = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    slots,
    children,
    className = '',
    layout,
    media,
    content,
    ...rest
  } = _ref;
  const {
    direction: layoutDirection = 'vertical',
    breakpoint: layoutBreakpoint
  } = layout || {};
  const {
    start: startSlot,
    end: endSlot
  } = slots || {};
  const {
    component: startSlotComponent,
    padded: startSlotPadded = true,
    absolute: startSlotAbsolute = false,
    gapless: startSlotGapless = false
  } = startSlot || {};
  const {
    component: endSlotComponent,
    padded: endSlotPadded = true
  } = endSlot || {};
  const {
    eyebrowProps,
    headingProps,
    subheadProps,
    descriptionProps,
    disclaimerProps,
    padded: contentPadded = true
  } = content || {};
  const {
    component: mediaComponent,
    padded: mediaPadded = false,
    position: mediaPosition,
    slot: mediaSlot
  } = media || {};
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: classnames(`b-card b-card--${layoutDirection}`, className, {
      [`b-card--breakpoint-${layoutBreakpoint}`]: layoutBreakpoint
    }),
    ref: ref,
    "data-testid": "card"
  }, rest), startSlotComponent && /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__slot', 'b-card__slot--start', {
      'b-card__slot--padded': startSlotPadded,
      'b-card__slot--absolute': startSlotAbsolute
    })
  }, startSlotComponent), (mediaPosition === 'beforeContent' || !mediaPosition) && mediaComponent && /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__media', {
      'b-card__media--padded': mediaPadded,
      'b-card__media--gapless': startSlotGapless
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "b-card__media-container"
  }, mediaComponent, mediaSlot?.component && /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__slot', 'b-card__slot--media', `b-card__slot--${mediaSlot.position || 'top-left'}`)
  }, mediaSlot.component))), /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__content', `b-card__content--${layout})}`, {
      'b-card__content--padded': contentPadded,
      'b-card__content--gapless': startSlotGapless && mediaPosition === 'afterContent'
    })
  }, eyebrowProps?.children && /*#__PURE__*/React__default.createElement(Subhead, _extends({
    type: "p"
  }, eyebrowProps, {
    className: classnames('b-card__eyebrow', eyebrowProps?.className),
    variant: eyebrowProps?.variant || 'subhead-sm'
  })), headingProps?.children && /*#__PURE__*/React__default.createElement(Heading, _extends({}, headingProps, {
    variant: headingProps?.variant || 'heading-md',
    className: classnames('b-card__heading', headingProps?.className)
  })), subheadProps?.children && /*#__PURE__*/React__default.createElement(Subhead, _extends({
    type: "p"
  }, subheadProps, {
    className: classnames('b-card__subhead', subheadProps?.className),
    variant: subheadProps?.variant || 'subhead-sm'
  })), descriptionProps?.children && /*#__PURE__*/React__default.createElement(Body, _extends({
    type: "p"
  }, descriptionProps, {
    className: classnames('b-card__description', descriptionProps?.className)
  })), disclaimerProps?.children && /*#__PURE__*/React__default.createElement(Body, _extends({
    type: "small"
  }, disclaimerProps, {
    className: classnames('b-card__disclaimer', disclaimerProps?.className)
  }))), mediaPosition === 'afterContent' && mediaComponent && /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__media', {
      'b-card__media--padded': mediaPadded
    })
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "b-card__media-container"
  }, mediaComponent, mediaSlot?.component && /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__slot', 'b-card__slot--media', `b-card__slot--${mediaSlot.position || 'top-left'}`)
  }, mediaSlot.component))), (endSlotComponent || children) && /*#__PURE__*/React__default.createElement("div", {
    className: classnames('b-card__slot', 'b-card__slot--end', {
      'b-card__slot--padded': endSlotPadded
    })
  }, children, endSlotComponent));
});
Card.displayName = 'Card';

export { Card };
